var r=e=>!!e;var ye=()=>[document?.documentElement?.lang].filter(r);export{ye as htmlLangAttributeDetector};
